'use client';

import { c as _c } from "react/compiler-runtime";
import { css } from '@repo/pandacss/css';
import { Grid } from '@repo/pandacss/jsx';
import { AnalyticsFeatureViewed as FeatureViewed } from '@repo/platform-analytics/AnalyticsFeatureViewed';
import { useAnalyticsSkuViewedContext } from '@repo/platform-analytics/AnalyticsSkuViewed/Context';
import { ElementViewed } from '@repo/platform-analytics/ElementViewed';
import { Skeleton } from '@repo/ui/Skeleton';
import type { ApprovalOddsValues } from '../../config/approvalOdds';
import { CardsApprovalLine } from './CardsApprovalLine';
import { approvalOddsSlotRecipe } from './styles';
export type CardsApprovalOddsProps = {
  approvalLikelihood: ApprovalOddsValues | null;
  isLoading?: boolean;
};
const CardsApprovalOdds = t0 => {
  const $ = _c(28);
  const {
    approvalLikelihood,
    isLoading
  } = t0;
  const {
    skuImpressionId
  } = useAnalyticsSkuViewedContext();
  const t1 = approvalLikelihood?.label ?? undefined;
  let t2;
  if ($[0] !== t1) {
    t2 = approvalOddsSlotRecipe({
      likelihood: t1
    });
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    container
  } = t2;
  if (isLoading) {
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <Skeleton css={{
        height: "[124px]"
      }} />;
      $[2] = t3;
    } else {
      t3 = $[2];
    }
    return t3;
  }
  let t3;
  if ($[3] !== approvalLikelihood?.label) {
    t3 = approvalLikelihood?.label?.toLowerCase();
    $[3] = approvalLikelihood?.label;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== skuImpressionId || $[6] !== t3) {
    t4 = {
      additional_attributes: {
        approval_odds: t3,
        parent_activity_id: skuImpressionId
      }
    };
    $[5] = skuImpressionId;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== approvalLikelihood?.label) {
    t5 = approvalLikelihood?.label?.toLowerCase();
    $[8] = approvalLikelihood?.label;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== skuImpressionId || $[11] !== t5) {
    t6 = {
      approval_odds: t5,
      sku_impression_id: skuImpressionId
    };
    $[10] = skuImpressionId;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = css({
      my: "1"
    });
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== approvalLikelihood) {
    t8 = <CardsApprovalLine approvalLikelihood={approvalLikelihood} />;
    $[14] = approvalLikelihood;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== container || $[17] !== t8) {
    t9 = <Grid columns={5} columnGap="1" className={container}>{t8}</Grid>;
    $[16] = container;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t7 || $[20] !== t9) {
    t10 = <div className={t7}>{t9}</div>;
    $[19] = t7;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t6) {
    t11 = <ElementViewed entityName="cc_approval_odds" sectionName="offer_product_card" itemPosition={0} additionalAttributes={t6}>{t10}</ElementViewed>;
    $[22] = t10;
    $[23] = t6;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t11 || $[26] !== t4) {
    t12 = <FeatureViewed entityName="cc_approval_odds" entitySection="" impressionPosition={0} additionalAttributes={t4}>{t11}</FeatureViewed>;
    $[25] = t11;
    $[26] = t4;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  return t12;
};
export default CardsApprovalOdds;